var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "kvm-sr-status",
          attrs: {
            "aria-live": "polite"
          }
        },
        [_vm._v(_vm._s(_vm.statusAnnouncement))]
      ),
      _vm.server.entitlement_status === "suspended"
        ? _c(
            "v-alert",
            {
              staticClass: "mb-4",
              attrs: {
                type: "warning",
                border: "left",
                prominent: ""
              }
            },
            [
              _vm._v(" This service is "),
              _c("strong", [_vm._v("suspended")]),
              _vm._v(". The server is stopped until it is reactivated. ")
            ]
          )
        : _vm.server.entitlement_status === "terminated"
        ? _c(
            "v-alert",
            {
              staticClass: "mb-4",
              attrs: {
                type: "error",
                border: "left",
                prominent: ""
              }
            },
            [
              _vm._v(" This service has been "),
              _c("strong", [_vm._v("terminated")]),
              _vm._v(". ")
            ]
          )
        : _vm._e(),
      _vm.loading && !_vm.server.provisioning_state
        ? _c("preloader")
        : _vm.error
        ? _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        type: "error",
                        border: "left",
                        prominent: ""
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.error.message ||
                              "This service could not be loaded."
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        tile: "",
                        color: "primary",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.loadServer
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            left: "",
                            small: ""
                          }
                        },
                        [_vm._v("mdi-refresh")]
                      ),
                      _vm._v("Retry ")
                    ],
                    1
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "hosting_kvm_list"
                        }
                      }
                    },
                    [_vm._v(" Back to servers ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.server.provisioning_state === "unprovisioned"
        ? _c("hosting-kvm-provision", {
            attrs: {
              "entitlement-id": _vm.server.id,
              region: _vm.server.location !== "—" ? _vm.server.location : ""
            },
            on: {
              provisioning: _vm.onProvisioningStarted
            }
          })
        : _vm.isBuilding
        ? _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "text-center pa-8"
                },
                [
                  _c("v-progress-circular", {
                    staticClass: "mb-4",
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: "48",
                      width: "4",
                      "aria-hidden": "true"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "body-1 mb-1"
                    },
                    [_vm._v(_vm._s(_vm.buildMessage))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "kvm-shell__hint"
                    },
                    [
                      _vm._v(
                        "This usually takes a minute or two. The page updates automatically."
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.isInstalling
        ? _c(
            "div",
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-6"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-center mb-4"
                        },
                        [
                          _c("v-progress-circular", {
                            staticClass: "mr-3",
                            attrs: {
                              indeterminate: "",
                              color: "primary",
                              size: "28",
                              width: "3",
                              "aria-hidden": "true"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "body-1"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.install.label || "Setting up your server…"
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.install.detailed
                        ? [
                            _c("v-progress-linear", {
                              staticClass: "mb-1",
                              attrs: {
                                value: _vm.install.percent || 0,
                                height: "8",
                                rounded: "",
                                color: "primary",
                                "aria-hidden": "true"
                              }
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "kvm-shell__hint text-caption mb-4"
                              },
                              [_vm._v(_vm._s(_vm.install.percent || 0) + "%")]
                            )
                          ]
                        : _vm._e(),
                      _vm.installSteps.length
                        ? _c(
                            "v-list",
                            {
                              staticClass: "py-0",
                              attrs: {
                                dense: ""
                              }
                            },
                            _vm._l(_vm.installSteps, function(step) {
                              return _c(
                                "v-list-item",
                                {
                                  key: step.key,
                                  staticClass: "px-0",
                                  staticStyle: {
                                    "min-height": "32px"
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        small: "",
                                        color: _vm.stepColor(step.status),
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.stepIcon(step.status)))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "kvm-shell__muted":
                                          step.status === "pending" ||
                                          step.status === "skipped"
                                      }
                                    },
                                    [_vm._v(_vm._s(step.label))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "kvm-shell__sr"
                                    },
                                    [_vm._v(" — " + _vm._s(step.status))]
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "kvm-shell__hint mt-4"
                        },
                        [
                          _vm._v(
                            "This page updates automatically — you don't need to refresh."
                          )
                        ]
                      ),
                      _c("kvm-deploy-log", {
                        staticClass: "mt-5",
                        attrs: {
                          "entitlement-id": _vm.server.id,
                          capable: _vm.deployLogsCapable,
                          active: _vm.isInstalling
                        }
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.installFailed && _vm.onIndex
        ? _c(
            "div",
            [
              _c(
                "gg-card",
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "v-alert",
                        {
                          staticClass: "mb-4",
                          attrs: {
                            type: "error",
                            border: "left",
                            prominent: ""
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.server.install &&
                                  _vm.server.install.label) ||
                                  "Your server was created but the application failed to install."
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            tile: "",
                            color: "primary",
                            loading: _vm.loading
                          },
                          on: {
                            click: _vm.loadServer
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: ""
                              }
                            },
                            [_vm._v("mdi-refresh")]
                          ),
                          _vm._v("Refresh ")
                        ],
                        1
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            tile: "",
                            outlined: "",
                            color: "primary",
                            to: {
                              name: "hosting_kvm_rebuild",
                              params: {
                                hostingid: _vm.server.id
                              }
                            }
                          }
                        },
                        [_vm._v(" Rebuild ")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            tile: "",
                            outlined: "",
                            color: "primary",
                            to: {
                              name: "hosting_kvm_list"
                            }
                          }
                        },
                        [_vm._v(" Back to servers ")]
                      ),
                      _c("kvm-deploy-log", {
                        staticClass: "mt-5",
                        attrs: {
                          "entitlement-id": _vm.server.id,
                          capable: _vm.deployLogsCapable,
                          active: false
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.buildFailed && _vm.onIndex
        ? _c(
            "gg-card",
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        type: "error",
                        border: "left",
                        prominent: ""
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.server.last_error ||
                              "Your server could not be provisioned. Please contact support if this persists."
                          ) +
                          " "
                      )
                    ]
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        tile: "",
                        color: "primary",
                        loading: _vm.loading
                      },
                      on: {
                        click: _vm.loadServer
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            left: "",
                            small: ""
                          }
                        },
                        [_vm._v("mdi-refresh")]
                      ),
                      _vm._v("Refresh ")
                    ],
                    1
                  ),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        tile: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "hosting_kvm_rebuild",
                          params: {
                            hostingid: _vm.server.id
                          }
                        }
                      }
                    },
                    [_vm._v(" Rebuild ")]
                  ),
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        tile: "",
                        outlined: "",
                        color: "primary",
                        to: {
                          name: "hosting_kvm_list"
                        }
                      }
                    },
                    [_vm._v(" Back to servers ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.isReady
        ? _c(
            "div",
            [
              _c(
                "v-row",
                {
                  staticClass: "mb-6"
                },
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-card",
                        [
                          _c(
                            "gg-card-text",
                            {
                              staticClass: "pa-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-center mb-3"
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "pb-1 mr-2",
                                      attrs: {
                                        size: "24",
                                        color: "primary",
                                        "aria-hidden": "true"
                                      }
                                    },
                                    [_vm._v("mdi-server")]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "body-1"
                                    },
                                    [_vm._v(_vm._s(_vm.server.label))]
                                  ),
                                  _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        "aria-label": "Rename this server",
                                        title: "Rename"
                                      },
                                      on: {
                                        click: _vm.openRename
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: ""
                                          }
                                        },
                                        [_vm._v("mdi-pencil")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "mr-auto",
                                      attrs: {
                                        role: "status",
                                        "aria-live": "polite"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pb-1",
                                          attrs: {
                                            small: "",
                                            color: _vm.powerColor,
                                            "aria-hidden": "true"
                                          }
                                        },
                                        [_vm._v("mdi-circle")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "kvm-shell__sr"
                                        },
                                        [_vm._v("Power state: ")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pl-1 text-capitalize"
                                        },
                                        [_vm._v(_vm._s(_vm.powerLabel))]
                                      )
                                    ],
                                    1
                                  ),
                                  _c("kvm-power-menu", {
                                    attrs: {
                                      server: _vm.server,
                                      pending: _vm.pendingPower
                                    },
                                    on: {
                                      action: _vm.runPower
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        sm: "6",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "kvm-shell__label"
                                        },
                                        [_vm._v("Hostname")]
                                      ),
                                      _c("div", [
                                        _vm._v(_vm._s(_vm.server.hostname))
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        sm: "6",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "kvm-shell__label"
                                        },
                                        [_vm._v("Primary IP")]
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _c("kvm-copyable", {
                                            attrs: {
                                              value: _vm.server.primary_ip
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        sm: "6",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "kvm-shell__label"
                                        },
                                        [_vm._v("Location")]
                                      ),
                                      _c("div", [
                                        _vm._v(_vm._s(_vm.server.location))
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        cols: "12",
                                        sm: "6",
                                        md: "3"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "kvm-shell__label"
                                        },
                                        [_vm._v("Operating System")]
                                      ),
                                      _c("div", [_vm._v(_vm._s(_vm.server.os))])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading,
                    type: "image",
                    height: "400"
                  }
                },
                [
                  _c(
                    "keep-alive",
                    {
                      attrs: {
                        include: "HostingKvmConsole"
                      }
                    },
                    [
                      _c("router-view", {
                        attrs: {
                          server: _vm.server,
                          loading: _vm.loading,
                          "on-refresh": _vm.loadServer,
                          "on-power-change": _vm.watchPower
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c("preloader"),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "440"
          },
          model: {
            value: _vm.rename.open,
            callback: function callback($$v) {
              _vm.$set(_vm.rename, "open", $$v)
            },
            expression: "rename.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-rename-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "body-1 font-weight-medium mb-2",
                      attrs: {
                        id: "kvm-rename-title"
                      }
                    },
                    [_vm._v("Rename this server")]
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "text-caption mb-3"
                    },
                    [
                      _vm._v(
                        " A name for this server in your account. It doesn't change anything on the server — the hostname is set separately (VPS Details → Hostname). Leave it empty to show the hostname. "
                      )
                    ]
                  ),
                  _c("v-text-field", {
                    attrs: {
                      label: "Server name",
                      outlined: "",
                      dense: "",
                      counter: "64",
                      maxlength: "64",
                      placeholder: _vm.server.hostname,
                      autocomplete: "off"
                    },
                    on: {
                      keyup: function keyup($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.saveRename($event)
                      }
                    },
                    model: {
                      value: _vm.rename.value,
                      callback: function callback($$v) {
                        _vm.$set(_vm.rename, "value", $$v)
                      },
                      expression: "rename.value"
                    }
                  }),
                  _vm.rename.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mb-0",
                          attrs: {
                            type: "warning",
                            dense: "",
                            text: "",
                            role: "alert"
                          }
                        },
                        [_vm._v(_vm._s(_vm.rename.error))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.rename.saving
                          },
                          on: {
                            click: function click($event) {
                              _vm.rename.open = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            tile: "",
                            color: "primary",
                            loading: _vm.rename.saving
                          },
                          on: {
                            click: _vm.saveRename
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }